import api from '@util/axios'

class Lincoln {
  async triggerDedupeUpdate(email) {
    return await api({
      url: '/lincoln/webhooks/dedupe-update/trigger/',
      method: 'POST',
      data: {
        email: email
      }
    })
  }

  async getParameters({ role, role_value, umr_criteria, fcp }) {
    return await api({
      url: '/get/parameters/',
      method: 'POST',
      data: {
        ...(role ? { role } : null),
        ...(role_value ? { role_value } : null),
        ...(umr_criteria ? { umr_criteria } : null),
        ...(fcp ? { fcp } : null)
      }
    })
  }

  async getClaimReferences(UMR, attachedBy = 'UMR') {
    return await api({
      url: '/lincoln/api/get/claim-reference/',
      method: 'POST',
      data: {
        UMR: UMR,
        attached_by: attachedBy
      }
    })
  }

  async getFCPReportDate({ umr, claim_reference }) {
    return await api({
      url: '/lincoln/fcp-fetch-report-date/',
      params: {
        umr,
        claim_reference
      }
    })
  }
}

export default new Lincoln()
